import capitalizeFirstLetter from 'ToolboxUtils/general/capitalize-first-letter';

const formatWeekDay  = ({ date, language }) => {
  return capitalizeFirstLetter(date.toLocaleDateString(language, {
    weekday: 'long'
  }));
};

export default formatWeekDay;